import React, { PropsWithChildren } from "react";
import {
  View,
  Platform,
  TextInput,
  StyleSheet,
  TextInputProps,
} from "react-native";
import Icon from "component/typography/Icon";
import Text from "component/typography/Text";

import { sizes, colors } from "asset/constant";
import fonts from "asset/fonts";
import { useSN } from "hook";

const TextArea = (props: PropsWithChildren<TextInputT & TextInputProps>) => {
  const { lang, icon, style, inputRef, leftComponent, hideError, error } =
    props;

  const sn = useSN();

  return (
    <>
      <View style={{ ...styles.container, ...style }}>
        {leftComponent}
        <TextInput
          multiline
          ref={inputRef}
          {...(props as TextInputProps)}
          style={{
            ...styles.input,
            paddingTop: sn(6, 8, 11, 12),
            fontFamily: lang ? fonts[lang].default : fonts.fa.default,
          }}
          placeholderTextColor={colors.text.placeholder}
        />
        <View style={styles.iconContainer}>
          {icon && <Icon size={22} {...icon} style={{ bottom: 4 }} />}
        </View>
      </View>
      {!hideError && (
        <View style={styles.errorContainer}>
          <Text size={"xs"} color={colors.danger}>
            {error}
          </Text>
        </View>
      )}
    </>
  );
};

export default TextArea;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 120,
    borderWidth: 1,
    overflow: "hidden",
    flexDirection: "row",
    justifyContent: "flex-end",
    borderColor: colors.border.normal,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.bg.element,
    alignItems: "flex-start",
  },

  iconContainer: {
    aspectRatio: 1,
    width: 48,
    alignItems: "center",
    justifyContent: "center",
  },

  labelContainer: {
    width: "100%",
    alignItems: "flex-end",
  },

  input: {
    ...(Platform.OS === "web" && { outlineColor: colors.transparent }),
    textAlignVertical: "top",
    fontSize: 14,
    flex: 1,
    lineHeight: 22,
    textAlign: "right",
    paddingLeft: 5,
    paddingRight: 2,
    color: colors.text.normal,
  },

  errorContainer: {
    width: "100%",
    alignSelf: "flex-end",
    height: 20,
    marginBottom: 10,
    paddingHorizontal: 5,
    bottom: Platform.OS === "web" ? -2 : 3,
  },
});
